import { render, staticRenderFns } from "./FabricListingListView.vue?vue&type=template&id=f584778c&scoped=true"
import script from "./FabricListingListView.vue?vue&type=script&lang=js"
export * from "./FabricListingListView.vue?vue&type=script&lang=js"
import style0 from "./FabricListingListView.vue?vue&type=style&index=0&id=f584778c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f584778c",
  null
  
)

export default component.exports